export const themePreferenceStorageKey = 'xinchaovietnam.theme-preference'

export type ThemePreference = 'light' | 'dark' | 'system'
export type ResolvedTheme = Exclude<ThemePreference, 'system'>

export function isThemePreference(value: unknown): value is ThemePreference {
  return value === 'light' || value === 'dark' || value === 'system'
}

export function readThemePreference(): ThemePreference {
  if (typeof window === 'undefined') return 'system'

  try {
    const storedPreference = window.localStorage.getItem(themePreferenceStorageKey)
    return isThemePreference(storedPreference) ? storedPreference : 'system'
  } catch {
    return 'system'
  }
}

export function resolveTheme(
  preference: ThemePreference,
  prefersDark: boolean,
): ResolvedTheme {
  if (preference === 'system') return prefersDark ? 'dark' : 'light'
  return preference
}

export function getSystemPrefersDark() {
  return typeof window !== 'undefined' &&
    window.matchMedia('(prefers-color-scheme: dark)').matches
}

export function applyResolvedTheme(
  preference: ThemePreference,
  resolvedTheme: ResolvedTheme,
) {
  if (typeof document === 'undefined') return

  const root = document.documentElement
  root.classList.toggle('dark', resolvedTheme === 'dark')
  root.dataset.theme = resolvedTheme
  root.dataset.themePreference = preference
  root.style.colorScheme = resolvedTheme
}

export function persistThemePreference(preference: ThemePreference) {
  if (typeof window === 'undefined') return

  try {
    window.localStorage.setItem(themePreferenceStorageKey, preference)
  } catch {
    // Theme persistence is an enhancement and must never block the learner runtime.
  }
}
